import store from '@/store';
import Spare_module from '@/spare/module';

export default {
  modelName: 'translation',
  label: '翻譯管理',
  fields: {
    sequence: {
      type: 'text',
      label: '排序',
    },
    content_text: {
      type: 'text',
      label: '文案',
      getText: ({label}) => label,
      disabled: true,
    },
    text: {
      type: 'textarea',
      label: '翻譯內容',
      maxlength: 10000,
    },
    locale: {
      type: 'text',
      label: '語言',
      readonly: true,
      getText: ({name}) => name,
    },
    topic: {
      type: 'text',
      label: '主題',
      readonly: true,
      getText: ({locales}) => {
        const currentLocale = store.state.locale.selectingLocale;
        return locales[currentLocale] ? locales[currentLocale].name : 'default';
      },
    },
    lang: {
      type: 'text',
      label: '語言代號',
      readonly: true,
    },
    for: {
      type: 'select',
      label: '適用前後台',
      readonly: true,
      items: [
        {
          text: '前台',
          value: 'app',
        },
        {
          text: '後台',
          value: 'platform',
        },
      ],
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    module: {
      type: 'select',
      label: '模組',
      readonly: true,
      items: Spare_module.list,
    },
  },
};
